import { useEffect, useState } from "react";
import { Offers } from "../lib/api";
import { MessageCircle, Sparkles, Calendar } from "lucide-react";
import { buildWaLink } from "../data/menuData";

export default function OffersSection() {
  const [offers, setOffers] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    Offers.list()
      .then(setOffers)
      .catch(() => setOffers([]))
      .finally(() => setLoaded(true));
  }, []);

  if (!loaded || offers.length === 0) return null;

  return (
    <section
      id="offers"
      data-testid="offers-section"
      className="bg-[#FFF9E6] border-b-2 border-black"
    >
      <div className="mx-auto max-w-7xl px-5 md:px-10 lg:px-16 py-16 md:py-20">
        <div className="max-w-3xl mb-8 md:mb-10">
          <div className="inline-flex items-center gap-2 brutal-border bg-[#D92525] text-white px-3 py-1 text-xs font-bold uppercase tracking-widest mb-4">
            <Sparkles size={14} strokeWidth={3} /> Today's Offers
          </div>
          <h2 className="font-display text-5xl md:text-6xl lg:text-7xl uppercase leading-[0.95] text-black">
            Hot deals <span className="text-[#D92525]">right now</span>!
          </h2>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {offers.map((o) => (
            <div
              key={o.id}
              data-testid={`offer-card-${o.id}`}
              className="brutal-border brutal-shadow-lg bg-white p-6 flex flex-col"
            >
              <div className="flex items-start justify-between gap-3">
                <h3 className="font-display text-2xl md:text-3xl uppercase leading-tight text-black flex-1">
                  {o.title}
                </h3>
                {o.price != null && (
                  <div className="font-display text-3xl md:text-4xl text-[#D92525] whitespace-nowrap">
                    ₹{o.price}
                  </div>
                )}
              </div>
              <p className="mt-3 text-sm text-neutral-800 leading-relaxed flex-1">
                {o.description}
              </p>
              {o.valid_until && (
                <div className="mt-4 inline-flex items-center gap-1.5 text-[11px] uppercase tracking-widest font-bold text-neutral-700">
                  <Calendar size={12} /> Valid till {o.valid_until}
                </div>
              )}
              <a
                href={buildWaLink(`Today's Offer — ${o.title}`)}
                target="_blank"
                rel="noreferrer"
                className="mt-5 inline-flex items-center justify-center gap-2 brutal-border brutal-shadow bg-[#25D366] text-black font-bold px-4 py-3 text-xs uppercase tracking-widest"
              >
                <MessageCircle size={14} strokeWidth={3} />
                Order This Offer
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
